import * as React from "react";

/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import validator from "validator";
import * as moment from "moment";

export const required = (value) => {
    if (!value) {
        return "Ce champ est obligatoire";
    }
    return null;
};

export const email = (value) => {
    if (!validator.isEmail(value)) {
        return `${value} is not a valid email.`;
    }
    return null;
};

export const ageMin16 = (value) => {
    if (moment().diff(value, "years") < 16) {
        return "l'âge minimum est 16 ans";
    }
    return null;
};

export const lt = (value, props) => {
    if (!value.toString().trim().length > props.maxLength) {
        return <span className="error">The value exceeded {props.maxLength} symbols.</span>;
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/validators/index.tsx